import {api_v1} from 'utils/api-client';
import conf from 'config/app-config';
import _ from 'lodash';

/**
 * Get all users
 */

const {initialPageSize, bufferSize} = conf.scroll;

export function getAssets(userId, programmerId, numberOfItems, startItem = 0, searchPrivateAssets = true) {
    if (_.isUndefined(numberOfItems)) {
        numberOfItems = initialPageSize + bufferSize;
    }
    return api_v1.get('/assets', {
        params: {
            MY_GALLERY: '',
            user: userId + '',
            prog: '-1',
            format: 'IMAGE|VIDEO|GIF',
            sortBy: 'date',
            numberOfItems,
            startItem,
            searchPrivateAssets
        }
    });
}

export function getAsset(uuid, selectedOrganization) {
    return new Promise((resolve, reject) => {
        api_v1.get(`/assets/${uuid}`, {
          headers: {
            'organization-id': selectedOrganization
          }
        }).then(response => {
            if  (response.data.response !== 'OK' || _.isEmpty(response.data.assets)) {
                reject (`No such asset ${uuid}` );
            }
            resolve(response.data.assets[0].metadata);
        }).catch(error => {
            reject({
                message: "Error getting asset",
                error
            })
        });
    });
}

export function deleteAsset(uuid) {
    return new Promise((resolve, reject) => {
        api_v1.delete(`/assets/${uuid}`).then(response => {
            resolve(response.status);
        }, data => {
            reject(data.response.status);
        });
    });
}
